// Phase 6 — Track E T-E3. Stack primitive (hand-rolled).
//
// Vertical flex with a token-keyed gap. The gap accepts the same
// numeric keys the spacing tokens expose (1, 2, 3, …) so a Stack with
// gap=4 matches Tailwind's `gap-4` (16px).

import * as React from 'react';
import { cn } from '../../lib/cn.js';

const gapClass: Record<number, string> = {
  0: 'gap-0',
  1: 'gap-1',
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  5: 'gap-5',
  6: 'gap-6',
  8: 'gap-8',
  10: 'gap-10',
  12: 'gap-12',
};

const alignClass = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
} as const;

const justifyClass = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
} as const;

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: keyof typeof gapClass;
  align?: keyof typeof alignClass;
  justify?: keyof typeof justifyClass;
  asChild?: boolean;
}

export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ className, gap = 4, align, justify, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex flex-col',
        gapClass[gap],
        align && alignClass[align],
        justify && justifyClass[justify],
        className,
      )}
      {...props}
    />
  ),
);
Stack.displayName = 'Stack';
